import { render, staticRenderFns } from "./appDownloadNew.vue?vue&type=template&id=4c543450&scoped=true&"
import script from "./appDownloadNew.vue?vue&type=script&lang=js&"
export * from "./appDownloadNew.vue?vue&type=script&lang=js&"
import style0 from "./appDownloadNew.vue?vue&type=style&index=0&id=4c543450&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c543450",
  null
  
)

export default component.exports